
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/to-whom",
      function () {
        return require("private-next-pages/to-whom.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/to-whom"])
      });
    }
  